import UserAvatar from "../UserAvatar/UserAvatar";
import { 
  StackedAvatarsContainer,
  FirstAvatar,
  SecondAvatar,
  ThirdAvatar,
  FourthAvatar,
  FifthAvatar,
} from "./StackedUserAvatars.styles";

interface StackedUserAvatarsProps extends React.HTMLAttributes<HTMLImageElement>{
  images?: string[]
}

function StackedUserAvatars(props: StackedUserAvatarsProps) {
  const {images, ...rest} = props;

  if (!images || images.length === 0) return <StackedAvatarsContainer/>

  return (
    <StackedAvatarsContainer>
      <FirstAvatar>
        <UserAvatar image={images[0] || ''}/>
      </FirstAvatar>
      {images[1] && <SecondAvatar>
        <UserAvatar image={images[1]}/>
      </SecondAvatar>}
      {images[2] && <ThirdAvatar>
        <UserAvatar image={images[2]}/>
      </ThirdAvatar>}
      {images[3] && <FourthAvatar>
        <UserAvatar image={images[3]}/>
      </FourthAvatar>}
      {images[4] && <FifthAvatar>
        <UserAvatar image={images[4]}/>
      </FifthAvatar>}
    </StackedAvatarsContainer>
  );
}

export default StackedUserAvatars;
